import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    barWrapper: {
        paddingBottom: theme.spacing.unit * 4,
        paddingTop: theme.spacing.unit * 4,
        textAlign: 'center',
    },
    fullWidth: {
        maxWidth: '100%',
        width: '100%',
    }
} );

const LoadingBar = ( { classes } ) => {
    return (
        <div className={classes.barWrapper}>
            <LinearProgress className={classes.fullWidth}/>
        </div>
    );
};

LoadingBar.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles( styles )( LoadingBar );
